import { Card } from '../../components/Card';
import { CardHeading } from '../components/CardHeading';
import { createUseStyles } from 'react-jss';
import { CheckinIcon } from '../components/CheckinIcon';
import { ICheckinTag } from '../model/ICheckin';
import { CheckinDetailsConfig, ICheckinDetailsType } from '../model/CheckinDetailsConfig';

const useStyles = createUseStyles({
    icons: {
        marginTop: 18,
        display: 'grid',
        gridRowGap: 28,
        justifyItems: 'center',
        gridTemplateColumns: 'repeat(4, 1fr)'
    }
});

interface ICheckinsDetailsCardProps {
    type: ICheckinDetailsType;
    title?: string;
    tags: ICheckinTag[];
    onAdd?: (tag: ICheckinTag) => void;
    onRemove?: (tag: ICheckinTag) => void;
    onChange?: (tags: ICheckinTag[]) => void;
    readonly?: boolean;
};

export const CheckinDetailsCard: React.FC<ICheckinsDetailsCardProps> = ({ type, title, tags, onAdd, onRemove, onChange, readonly }) => {
    const classes = useStyles();

    const typeConfig = CheckinDetailsConfig[type];

    const isActive = (tag: ICheckinTag) => {
        return tags.some(t => t === tag);
    };

    const clickHandler = (tag: ICheckinTag) => {
        let updatedTags: ICheckinTag[];
        if (tags.includes(tag)) {
            updatedTags = tags.filter(t => t !== tag);
            if (onRemove) {
                onRemove(tag);
            }
        } else {
            updatedTags = [...tags, tag];
            if (onAdd) {
                onAdd(tag);
            }
        }
        if (onChange) {
            onChange(updatedTags);
        }
    };

    return (
        <Card padded>
            <CardHeading>{title || typeConfig.title}</CardHeading>
            <div className={classes.icons}>
                {typeConfig.icons.map(config => (
                    <CheckinIcon
                        key={config.label}
                        data-type={type}
                        data-id={config.label}
                        Icon={config.Icon}
                        label={config.label}
                        active={isActive(config.label)}
                        activeColor={config.activeColor}
                        onClick={readonly ? undefined : () => clickHandler(config.label)}
                    />
                ))}
            </div>
        </Card>
    );
};
